import {
    createSlice,
    createAsyncThunk
} from "@reduxjs/toolkit";

import axiosClient
    from "../../servics/axiosClient";


// ============================================================
// RESTORE TENANT USER FROM LOCAL STORAGE
// ============================================================

const getStoredTenantUser = () => {

    try {

        const storedUser =
            localStorage.getItem(
                "tenantUser"
            );

        if (!storedUser) {
            return null;
        }

        return JSON.parse(storedUser);

    } catch (error) {

        console.error(
            "Impossible de restaurer tenantUser",
            error
        );

        localStorage.removeItem(
            "tenantUser"
        );

        return null;
    }
};


// ============================================================
// FETCH USER BY ID
// ============================================================

export const fetchTenantUserById =
    createAsyncThunk(

        "tenantUser/fetchTenantUserById",

        async (
            tenantUserId,
            thunkAPI
        ) => {

            try {

                const response =
                    await axiosClient.get(
                        `/users/getById/${tenantUserId}`
                    );

                return response.data;

            } catch (error) {

                return thunkAPI.rejectWithValue(
                    error.response?.data ||
                    error.message
                );
            }
        }
    );


// ============================================================
// INITIAL STATE
// ============================================================

const initialState = {

    tenantUser:
        getStoredTenantUser(),

    loading: false,

    error: null
};


// ============================================================
// SLICE
// ============================================================

const tenantUserSlice = createSlice({

    name: "tenantUser",

    initialState,

    reducers: {

        setTenantUser(state, action) {

            state.tenantUser =
                action.payload;

            localStorage.setItem(
                "tenantUser",
                JSON.stringify(
                    action.payload
                )
            );
        },

        clearTenantUser(state) {

            state.tenantUser = null;

            state.loading = false;

            state.error = null;

            localStorage.removeItem(
                "tenantUser"
            );
        }
    },

    extraReducers: (builder) => {

        builder

            // ================================================
            // REQUEST
            // ================================================

            .addCase(
                fetchTenantUserById.pending,
                (state) => {

                    state.loading = true;

                    state.error = null;
                }
            )

            // ================================================
            // SUCCESS
            // ================================================

            .addCase(
                fetchTenantUserById.fulfilled,
                (state, action) => {

                    state.loading = false;

                    state.tenantUser =
                        action.payload;

                    state.error = null;

                    // Persist user
                    localStorage.setItem(
                        "tenantUser",
                        JSON.stringify(
                            action.payload
                        )
                    );
                }
            )

            // ================================================
            // ERROR
            // ================================================

            .addCase(
                fetchTenantUserById.rejected,
                (state, action) => {

                    state.loading = false;

                    state.error =
                        action.payload;
                }
            );
    }
});


export const {
    setTenantUser,
    clearTenantUser
} = tenantUserSlice.actions;


export default tenantUserSlice.reducer;